// const listStyle = {
//   listStyleType: 'disc',
//   paddingLeft: '1.5rem',
//   marginTop: '0.5rem',
// };

export const OrgFAQs = [
    {
        question: "How do I launch a quest on Lunor?",
        answer: "Launching a quest is simple. Organizations can reach out to our team, and we will work closely with you to define your AI challenge, tailor the quest to your specific needs, and guide you through the entire process, including setting up the prize pool and securely managing data.",
    },
    {
        question: "Can I control who participates in my quest?",
        answer: "Yes, Lunor allows you to control participant access. You can choose to open your quest to all or limit it to a specific group of contributors to ensure relevance and quality.",
    },
    {
        question:
            "How does Lunor ensure the security of my data during quests?",
        answer: "Lunor uses secure Federated Learning, which allows AI models to train on decentralized data without transferring or exposing it. This ensures your sensitive data remains on-premise, safeguarding privacy and maintaining regulatory compliance while enabling collaboration.",
    },
    {
        question: "What kind of quests can I host on Lunor?",
        answer: "You can host quests tailored to any step of the AI pipeline, such as data collection, model creation, optimization, or evaluation. These can be applied across industries like healthcare, finance, logistics, retail, and more.",
    },
    {
        question: "How are submissions evaluated?",
        answer: "You can choose to have submissions peer-reviewed by the Lunor community or evaluated by your own selected reviewers. This flexibility ensures the evaluation process meets your organization's standards.",
    },
    {
        question:
            "Who owns the IP for the solutions developed in the quests?",
        answer: "The hosting organization retains full IP ownership unless otherwise specified in the quest terms. This ensures that all outcomes align with your business and regulatory requirements.",
    },
    {
        question: "What industries does Lunor serve?",
        answer: "Lunor serves industries like healthcare, finance, logistics, retail, and beyond. Our versatile platform supports organizations in any sector to crowdsource innovative AI solutions.",
    },
    {
        question: "How much does it cost to host a quest on Lunor?",
        answer: "Costs vary based on the scope and complexity of the quest. Contact our team for a tailored pricing plan that suits your specific objectives.",
    },
    {
        question: "Can I scale my AI development across multiple quests?",
        answer: "Yes, Lunor supports scalable AI development. You can host multiple quests simultaneously or sequentially, tackling a variety of challenges to accelerate innovation.",
    },
    {
        question: "How does Lunor ensure regulatory compliance?",
        answer: "Lunor leverages secure Federated Learning to allow AI models to train on private data without transferring or exposing it. This ensures compliance with regulations like GDPR while maintaining data security and privacy.",
    },
]